import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  addVisaApplication_action,
  getVisaApplicationDetails_action,
  updateVisaApplication_action,
  deleteVisaApplicationDoc_action,
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/invitationVisaApplication_action/visaApplication_action";
import { fill_action } from "../../../../../actions/fillCombo_action";
import {
  BASE_URL,
  countryActionId,
  toastError,
  toastSuccess,
  visaIdTypeActionId,
  ListOfExhibitorBadgeActionId,
  genderActionId
} from "../../../../../utils/constants";
import { emailValidator, mobileNoValidator } from "../../../../../utils/Validator";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import Modal from "react-modal";
import DatePicker from "react-datepicker";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import Passport_Front_1008_VIS_903747 from "../../../../../files/Passport_Front_1008_VIS_903747.jpeg";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

class InvitationVisaApplicationAU extends Component {
  // initialize constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      is_add: false,
      is_update: false,
      isView: false,
      isDelOpen: false,
      passportFilePath: "",

      // fields
      firstName: "",
      lastName: "",
      middleName: "",
      email: "",
      countryId: "",
      mobile: "",
      idTypeId: "",
      passportNo: "",
      passportIssueDate: "",
      passportExpiryDate: "",
      passportFrontImage: "",
      passportFrontImageBase64: "",
      passportImage: "",
      passportFrontImageType: "",
      VisaApplicationFormID: "",
      // List
      visaApplicationList: [],
      countryList: [],
      idTypeList: [],
      passportFrontImageList: [],
      passportFrontImageTypeList: [],

      // err messages
      firstNameErr: "",
      lastNameErr: "",
      emailErr: "",
      countryIdErr: "",
      mobileErr: "",
      idTypeIdErr: "",
      passportNoErr: "",
      passportIssueDateErr: "",
      passportExpiryDateErr: "",
      passportFrontImageErr: "",
      url: "",
      Deadline: "",
      ListOfExhibitorBadgeList: [],
      ListOfExhibitorBadgeId: [],
      isPassportView: false,
      ExhibitorName: "",
      ContactPerson: "",
      ContactNumber: "",
      HallNo: "",
      StallNo: "",
      StallArea: "",
      fileIsFromBackend: false,
      Is_View:
        this.props.location.state != null && this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      RoleID: sessionStorage.getItem("RoleIDSS"),
      Gender: null,
      DateofBirth: null,
      Nationality: '',
      EmbassyOrConsulateOfficeLocation: '',
      genderList: [],
      companyName: '',
      companyNameErr: '',
      companyList: [],
      IsMixExhibitor: false
    };
    this.OnCancel = this.OnCancel.bind(this);
    this.inputValidate = this.inputValidate.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.renderVisaApplicationList = this.renderVisaApplicationList.bind(this);
    this.onFilePick = this.onFilePick.bind(this);
    this.onPdfSelect = this.onPdfSelect.bind(this);
    this.resizeFile = this.resizeFile.bind(this);
    this.handleAddMore = this.handleAddMore.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.ClearValue = this.ClearValue.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.getDetails = this.getDetails.bind(this);
    this.emailValidation = this.emailValidation.bind(this);
    this.onCrossClick = this.onCrossClick.bind(this);
    this.mobileValidation = this.mobileValidation.bind(this);
    this.onDocDelete = this.onDocDelete.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.handleSave()
      }
      if (confirmationObj.action == 1) {
        this.handleUpdate()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  componentDidMount() {
    this.getFillList(
      countryActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    this.getFillList(
      genderActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    this.getFillList(
      visaIdTypeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    this.getFillList(
      ListOfExhibitorBadgeActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    this.setState(
      {
        is_update:
          this.props.location.state != "" &&
            this.props.location.state.is_update != null &&
            this.props.location.state.is_update != false
            ? this.props.location.state.is_update
            : false,
        isView:
          this.props.location.state != "" && this.props.location.state.is_View
            ? this.props.location.state.is_View
            : false,

        is_add:
          this.props.location.state != "" &&
            this.props.location.state.is_add != null &&
            this.props.location.state.is_add != false
            ? this.props.location.state.is_add
            : false,
        VisaApplicationFormID:
          this.props.location.state != "" &&
            this.props.location.state.VisaApplicationFormID != null &&
            this.props.location.state.VisaApplicationFormID != ""
            ? this.props.location.state.VisaApplicationFormID
            : "",
        Deadline:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.Deadline != ""
            ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY").toString()
            : "",
        StatusID:
          this.props.location.state != null &&
            this.props.location.state != "" &&
            this.props.location.state.StatusID != null
            ? this.props.location.state.StatusID
            : false,
      },
      () => {
        this.getDetails();
      }
    );
    setTimeout(() => {
      console.log(this.state.VisaApplicationFormID);
      console.log("state value : ", this.props.location.state);
      this.props.location.state != "" &&
        (this.props.location.state.is_View != false ||
          this.props.location.state.is_update != false) &&
        this.getDetails();
      // this.props.location.state != "" && this.props.location.state.is_View != null && this.props.location.state.is_View != false && this.getDetails()
    }, 100);

    const url = BASE_URL.split("/api");
    this.setState({ url: url[0] });
  }

  // get Fill List
  getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          // Country List
          if (actionID === countryActionId) {
            console.log("country data", data.data);
            this.setState({
              countryList: data.data,
              isLoading: false,
            });
          }
          if (actionID === genderActionId) {
            this.setState({
              genderList: data.data,
              isLoading: false,
            });
          }
          // visa  id type
          if (actionID === visaIdTypeActionId) {
            console.log("visaIdTypeActionId data", data.data);
            this.setState({
              idTypeList: data.data,
              isLoading: false,
            });
          }
          if (actionID === ListOfExhibitorBadgeActionId) {
            this.setState({
              ListOfExhibitorBadgeList: data.data,
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  removeBackendFile = () => {
    this.setState({
      passportFrontImage: "",
      passportFilePath: "",
      fileIsFromBackend: false,
      passportImage: "",
    });
  };

  // On cancel Click
  OnCancel() {
    // this.props.navigate('/visaApplication')
    this.props.navigate(-1);
  }

  // Input Fields Validation
  inputValidate() {
    const {
      firstName,
      lastName,
      email,
      countryId,
      mobile,
      idTypeId,
      passportNo,
      passportFrontImage,
      passportExpiryDate,
      passportIssueDate,
      companyName,
    } = this.state;
    if (companyName.trim() == "") {
      this.setState({ companyNameErr: "Please Enter company Name" });
    }
    if (firstName.trim() == "") {
      this.setState({ firstNameErr: "Please Enter first Name" });
    }
    if (lastName.trim() == "") {
      this.setState({ lastNameErr: "Please Enter last Name" });
    }
    if (email.trim() == "") {
      this.setState({ emailErr: "Please Enter email" });
    }
    // if (email != "") {
    //     var emailError = emailValidator(email)
    //     if (emailError != '') {
    //         this.setState({ emailErr: emailError })
    //     }
    // }
    if (countryId == "") {
      this.setState({ countryIdErr: "Please select country" });
    }
    if (mobile.trim() == "") {
      this.setState({ mobileErr: "Please Enter mobile" });
    }
    // if (mobile != "") {
    //     var mobileError = mobileNoValidator(mobile)
    //     if (mobileError != '') {
    //         this.setState({ mobileErr: mobileError })
    //     }
    // }
    if (idTypeId == "") {
      this.setState({ idTypeIdErr: "Please select id type" });
    }
    if (passportNo.trim() == "") {
      this.setState({ passportNoErr: "Please Enter passport No" });
    }
    if (passportFrontImage == "") {
      this.setState({ passportFrontImageErr: "Please upload passport Front Image" });
    }
    if (passportIssueDate == "") {
      this.setState({ passportIssueDateErr: "Please Select Passport Issue Date" });
    }
    if (passportExpiryDate == "") {
      this.setState({ passportExpiryDateErr: "Please Select Passport Expiry Date" });
    }
  }

  // render Visa Application
  renderVisaApplicationList() {
    const { visaApplicationList, passportFrontImageList,
      passportFrontImage } = this.state;
    return (
      <ul class="list-group " style={{ position: "relative", zIndex: 1 }}>
        {visaApplicationList.length > 0 &&
          visaApplicationList.map((data, index) => (
            <li class="list-group-item" key={Math.random()}>
              <div className="added-more p-3 rounded-2">
                <h5 style={{ color: "#0056ff" }}>Added Visa Application {++index}</h5>
                <div className="row mt-4">
                  <div className="col-md-4">
                    <h6>First Name: {data.firstName}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Middel Name: {data.middleName}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Last Name: {data.lastName}</h6>
                  </div>
                </div>
                <div className="row mt-2">
                  <div className="col-md-4">
                    <h6>Email: {data.email}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Country: {data.countryName}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Mobile: {data.mobile}</h6>
                  </div>
                </div>
                <div className="row mt-2">
                  {/* <div className="col-md-4">
                    <h6>ID Type: {data.idTypeName}</h6>
                  </div> */}
                  <div className="col-md-4">
                    <h6>Passport No: {data.passportNo}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Passport Issue Date: {data.passportIssueDate.toDateString()}</h6>
                  </div>
                  <div className="col-md-4">
                    <h6>Passport Expiry Date: {data.passportExpiryDate.toDateString()}</h6>
                  </div>
                  <div className="col-md-4">
                    {/* <h6>Passport Front Page</h6> */}
                    <div
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "5px 16px",
                        margin: "10px 0",
                        borderRadius: "20px",
                        backgroundColor: "#f0f0f0",
                        gap: "12px",
                        position: "relative",
                      }}
                    >
                      <span
                        style={{
                          color: "#0066ffff",
                          cursor: "pointer",
                          textDecoration: "underline",
                          fontSize: "14px",
                          pointerEvents: "auto",
                        }}
                      >

                        <a
                          onClick={(e) => {
                            this.openPassportFile(
                              this.state.passportFrontImageList[index - 1],
                              data.passportFrontImage
                            );
                          }}
                        >
                          <span className="file-name-ellipsis">
                            {data.passportFrontImage}
                          </span>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <hr className="m-1" />
            </li>
          ))}
      </ul>
    );
  }

  emailValidation(e) {
    var emailError = emailValidator(e.target.value);
    this.setState({ email: e.target.value });
    if (emailError != "") {
      this.setState({ emailErr: emailError });
    } else {
      this.setState({ emailErr: "" });
    }
  }

  mobileValidation(e) {
    // var mobileError = mobileNoValidator(e.target.value)
    const event = e.target.value.replace(/\D/, "");
    if (event != "") {
      this.setState({ mobile: event, mobileErr: "" });
    } else {
      this.setState({ mobile: "" });
    }
    // if (mobileError != '') {
    //     this.setState({ mobileErr: mobileError })
    // }
    // else {
    //     this.setState({ mobileErr: '' })
    // }
  }

  // onFilePick = async (e, file) => {
  //   e.preventDefault();

  //   if (!file || file.length === 0) return;

  //   const selectedFile = file[0];

  //   // Validate size
  //   if (selectedFile.size >= 5 * 1024 * 1024) {
  //     return toastError("File size more than 5mb is not allowed.");
  //   }

  //   const fileName = selectedFile.name.toLowerCase();

  //   // Validate type
  //   const isImage =
  //     fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png");
  //   const isPdf = fileName.endsWith(".pdf");

  //   if (!isImage && !isPdf) {
  //     return toastError("Only .pdf, .jpeg, .png, .jpg files are allowed");
  //   }

  //   let base64 = "";

  //   // Convert to base64 (only for upload)
  //   if (isImage) {
  //     base64 = await this.resizeFile(selectedFile);
  //   } else if (isPdf) {
  //     base64 = await this.onPdfSelect(selectedFile);
  //   }

  //   // Save data
  //   this.setState({
  //     passportFrontImage: selectedFile.name, // ✅ show only file name
  //     passportFrontImageBase64: base64, // ✅ actual base64 for upload
  //     passportFrontImageErr: "",
  //     passportFrontImageType: selectedFile.type.split("/")[1],
  //   });
  // };
  onFilePick = async (e, file) => {
    e.preventDefault();

    if (!file || file.length === 0) return;

    const selectedFile = file[0];

    // Validate size
    if (selectedFile.size >= 5 * 1024 * 1024) {
      return toastError("File size more than 5mb is not allowed.");
    }

    const fileName = selectedFile.name.toLowerCase();

    // Validate type
    const isImage =
      fileName.endsWith(".jpg") || fileName.endsWith(".jpeg") || fileName.endsWith(".png");
    const isPdf = fileName.endsWith(".pdf");

    if (!isImage && !isPdf) {
      return toastError("Only .pdf, .jpeg, .png, .jpg files are allowed");
    }

    let base64 = "";

    // Convert to base64 (only for upload)
    if (isImage) {
      base64 = await this.resizeFile(selectedFile);
    } else if (isPdf) {
      base64 = await this.onPdfSelect(selectedFile);
    }

    // Extract file extension properly
    const fileExtension = selectedFile.type.split("/")[1]; // Gets 'pdf', 'jpeg', 'png'

    // Save data
    this.setState({
      passportFrontImage: selectedFile.name, //  show only file name
      passportFrontImageBase64: base64, //  actual base64 for upload
      passportFrontImageErr: "",
      passportFrontImageType: fileExtension, // Store ONLY extension, not full filename
    });
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      const reader = new FileReader();

      reader.onload = () => {
        resolve(reader.result);
      };

      reader.readAsDataURL(file);
    });

  handleAddMore() {
    const {
      visaApplicationList,
      passportFrontImageList,
      passportFrontImageTypeList,
      firstName,
      lastName,
      middleName,
      email,
      countryId,
      mobile,
      idTypeId,
      passportNo,
      passportFrontImage,
      passportFrontImageBase64,
      passportFrontImageType,
      countryList,
      idTypeList,
      firstNameErr,
      lastNameErr,
      emailErr,
      countryIdErr,
      mobileErr,
      idTypeIdErr,
      passportNoErr,
      passportFrontImageErr,
      passportExpiryDate,
      passportExpiryDateErr,
      passportIssueDate,
      passportIssueDateErr,
      ListOfExhibitorBadgeId,
      Gender, DateofBirth, Nationality, EmbassyOrConsulateOfficeLocation, companyName, companyNameErr
    } = this.state;
    this.inputValidate();
    if (
      companyName != "" &&
      firstName != "" &&
      countryId != "" &&
      lastName != "" &&
      mobile != "" &&
      email != "" &&
      passportNo != "" &&
      passportFrontImage != "" &&
      passportFrontImageType != "" &&
      passportIssueDate != "" &&
      passportExpiryDate != ""
    ) {
      if (
        firstNameErr == "" &&
        companyNameErr == "" &&
        lastNameErr == "" &&
        emailErr == "" &&
        countryIdErr == "" &&
        mobileErr == "" &&
        passportNoErr == "" &&
        passportFrontImageErr == "" &&
        passportExpiryDateErr == "" &&
        passportIssueDateErr == ""
      ) {
        console.log("fields", idTypeId);
        var countryName = "";
        var idTypeName = "";

        countryList.length > 0 &&
          countryList.map((data) => {
            if (data.Code == countryId) {
              countryName = data.Description;
            }
          });
        idTypeList.length > 0 &&
          idTypeList.map((data) => {
            if (data.FormDocumentTypeID == idTypeId) {
              idTypeName = data.Name;
            }
          });
        visaApplicationList.push({
          SeqNo: visaApplicationList.length + 1,
          firstName: firstName,
          middleName: middleName,
          lastName: lastName,
          email: email,
          countryId: countryId,
          countryName: countryName,
          mobile: mobile,
          idTypeId: idTypeId,
          idTypeName: idTypeName,
          passportNo: passportNo,
          passportFrontImage: passportFrontImage,
          passportIssueDate: passportIssueDate,
          passportExpiryDate: passportExpiryDate,
          ListOfExhibitorBadgeId: ListOfExhibitorBadgeId,
          Gender: Gender,
          DateofBirth: DateofBirth,
          Nationality: Nationality,
          EmbassyOrConsulateOfficeLocation: EmbassyOrConsulateOfficeLocation
        });
        passportFrontImageList.push(passportFrontImageBase64);
        passportFrontImageTypeList.push(passportFrontImageType);
        this.setState({ visaApplicationList: visaApplicationList });
        setTimeout(() => {
          this.ClearValue();
        }, 200);
      } else {
        toastError("Please enter proper fields");
      }
    } else {
      toastError("Please enter mandatory fields");
      console.log("Please enter mandatory fields");
    }
    console.log(this.state.visaApplicationList);
  }

  handleSave() {
    const { visaApplicationList, passportFrontImageList, passportFrontImageTypeList, Deadline, companyName } =
      this.state;
    this.setState({ isLoading: true });
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    this.props
      .addVisaApplication_action(
        visaApplicationList,
        passportFrontImageList,
        passportFrontImageTypeList,
        ManualFormsID,
        ServiceID,
        VendorDetails,
        companyName
      )
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Record Added Successfully");
          setTimeout(() => {
            this.setState({ isLoading: false });
            this.props.navigate("/visaApplication", { state: { Deadline: Deadline } });
          }, 300);
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleUpdate() {
    const {
      VisaApplicationFormID,
      visaApplicationList,
      passportFrontImageList,
      passportFrontImageTypeList,
      firstName,
      lastName,
      middleName,
      email,
      countryId,
      passportImage,
      Deadline,
      mobile,
      idTypeId,
      passportNo,
      passportFrontImage,
      passportFrontImageBase64,
      passportFrontImageType,
      countryList,
      idTypeList,
      firstNameErr,
      lastNameErr,
      emailErr,
      countryIdErr,
      mobileErr,
      idTypeIdErr,
      passportNoErr,
      passportFrontImageErr,
      passportExpiryDate,
      passportExpiryDateErr,
      passportIssueDate,
      passportIssueDateErr,
      Gender,
      DateofBirth,
      Nationality,
      EmbassyOrConsulateOfficeLocation,
      companyName,
      companyNameErr
    } = this.state;
    this.inputValidate();
    const hasFile = passportImage || (passportFrontImage && passportFrontImageType);
    if (
      companyName != "" &&
      firstName != "" &&
      countryId != "" &&
      lastName != "" &&
      mobile != "" &&
      email != "" &&
      passportExpiryDate != "" &&
      passportIssueDate != "" &&
      passportNo != "" &&
      hasFile
    ) {
      if (
        companyNameErr == "" &&
        firstNameErr == "" &&
        lastNameErr == "" &&
        emailErr == "" &&
        countryIdErr == "" &&
        mobileErr == "" &&
        // idTypeIdErr == "" &&
        passportNoErr == "" &&
        // If no backend file, then new file must be valid
        (!passportImage ? passportFrontImageErr === "" : true) &&
        passportExpiryDateErr == "" &&
        passportIssueDateErr == ""
      ) {
        this.setState({ isLoading: true });
        this.props
          .updateVisaApplication_action(
            VisaApplicationFormID,
            firstName,
            middleName,
            lastName,
            email,
            countryId,
            mobile,
            idTypeId,
            passportNo,
            passportFrontImageBase64,
            passportFrontImageType,
            passportIssueDate,
            passportExpiryDate,
            Gender,
            DateofBirth,
            Nationality,
            EmbassyOrConsulateOfficeLocation,
            companyName
          )
          .then((data) => {
            if (data.error != 1) {
              toastSuccess("Record updated Successfully");
              setTimeout(() => {
                this.setState({ isLoading: false });
                this.props.navigate("/visaApplication", { state: { Deadline: Deadline } });
              }, 300);
            } else {
              this.setState({ isLoading: false });
              toastError(data.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        toastError("Please enter mandatory feilds!");
      }
    } else {
      toastError("Please enter mandatory feilds!");
    }
  }

  getDetails() {
    const { VisaApplicationFormID } = this.state;
    this.setState({ isLoading: true });

    this.props
      .getVisaApplicationDetails_action(VisaApplicationFormID)
      .then((data) => {
        if (data.error !== 1) {
          const record = data.data[0]?.[0] || {};
          const exhibitor = data.data[1]?.[0] || {};

          this.setState({
            companyName: exhibitor.IsMixExhibitor ? record.CompanyName : exhibitor.ExhibitorName,
            IsMixExhibitor: exhibitor.IsMixExhibitor || "",
            companyList: data.data[2] || [],
            firstName: record.FirstName || "",
            lastName: record.LastName || "",
            middleName: record.MiddleName || "",
            email: record.Email || "",
            countryId: record.CountryID || "",
            mobile: record.MobileNo || "",
            idTypeId: record.FormDocumentTypeID || "",
            passportNo: record.PassportNo || "",
            passportIssueDate: record.PassportIssueDate ? new Date(record.PassportIssueDate) : "",
            passportExpiryDate: record.PassportExpiryDate
              ? new Date(record.PassportExpiryDate)
              : "",
            ExhibitorName: exhibitor.ExhibitorName || "",
            ContactPerson: exhibitor.ContactPerson || "",
            ContactNumber: exhibitor.ContactNumber || "",
            HallNo: exhibitor.HallNo || "",
            StallNo: exhibitor.StallNo || "",
            StallArea: exhibitor.StallArea || "",
            isLoading: false,
            fileIsFromBackend: true,

            Gender: record.Gender,
            DateofBirth: record.DateofBirth ? new Date(record.DateofBirth) : "",
            Nationality: record.Nationality,
            EmbassyOrConsulateOfficeLocation: record.EmbassyOrConsulateOfficeLocation,
          });
          // FILE HANDLING
          const filePath = record.PassportImage || "";
          if (filePath) {
            const fileName = filePath.split("/").pop();

            this.setState({
              passportFrontImage: fileName,
              passportFilePath: filePath ? filePath : `${window.location.origin}${filePath}`,
              fileIsFromBackend: true,
              is_add: false,
              passportFrontImageBase64: "",
              passportFrontImageErr: "",
              passportImage: filePath,
            });
          } else {
            this.setState({
              passportFrontImage: "",
              passportFilePath: "",
              fileIsFromBackend: false,
              is_add: true,
              passportFrontImageBase64: "",
              passportImage: "",
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ isLoading: false });
      });
  }

  openPassportFile = (base64String, fileName) => {
    // Extract MIME type and Base64 data
    const mimeType = base64String.split(";")[0].split(":")[1]; // Extract MIME type (e.g., 'image/png' or 'application/pdf')
    const byteCharacters = atob(base64String.split(",")[1]); // Extract Base64 content
    const byteNumbers = Array.from(byteCharacters).map((char) => char.charCodeAt(0));
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: mimeType });

    // Create a URL for the Blob
    const fileURL = URL.createObjectURL(blob);

    if (mimeType.startsWith("image/") || mimeType === "application/pdf") {
      // Open viewable files directly
      const newTab = window.open(fileURL, "_blank", "noopener,noreferrer");
      if (newTab) {
        newTab.document.title = fileName; // Set the tab title to the file name
      }
    } else {
      // Download non-viewable files
      const link = document.createElement("a");
      link.href = fileURL;
      link.download = fileName; // Use the specific file name for the download
      link.click();
    }

    // Clean up the blob URL after the file action
    setTimeout(() => URL.revokeObjectURL(fileURL), 500);
  };

  ClearValue() {
    this.setState({
      firstName: "",
      lastName: "",
      middleName: "",
      email: "",
      countryId: "",
      mobile: "",
      idTypeId: "",
      passportNo: "",
      passportFrontImage: "",
      passportFrontImageBase64: "",
      passportImage: "",
      ListOfExhibitorBadgeId: "",
      passportExpiryDate: "",
      passportIssueDate: "",
      passportFrontImageType: "",
      passportFilePath: "",
      fileIsFromBackend: false,
    });
    // document.getElementById("path").value = ""

    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  }

  onCrossClick() {
    this.setState({
      passportFrontImage: "",
      passportFrontImageBase64: "",
      passportFilePath: "",
      fileIsFromBackend: false,
      passportFrontImageErr: "",
      passportImage: "",
    });

    const fileInput = document.querySelector('input[type="file"]');
    if (fileInput) {
      fileInput.value = "";
    }
  }

  // On Document Delete Modal Toggle
  onDocDelete() {
    const { isDelOpen } = this.state;
    this.setState({ isDelOpen: !isDelOpen });
  }

  // Delete Passport Document Delete
  handleDelete(e) {
    e.preventDefault();
    const { isDelOpen, VisaApplicationFormID, passportImage } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteVisaApplicationDoc_action(VisaApplicationFormID)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Passport Front Image Document Deleted SuccessFully");
          this.setState({ isLoading: false, isDelOpen: !isDelOpen, passportImage: "" });
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  onSelectListofExhibitor(e) {
    const { ListOfExhibitorBadgeList, visaApplicationList } = this.state;
    this.setState({
      middleName: "",
      lastName: "",
    });
    this.setState({ isLoading: true });
    if (e.target.value != "" && e.target.value != "Select") {
      const checkedValue = visaApplicationList.some(
        (item) => item.ListOfExhibitorBadgeId == e.target.value
      );
      if (!checkedValue) {
        ListOfExhibitorBadgeList.map((data) => {
          if (data.ExhBadgesFormID == e.target.value) {
            const nameList = data.Name.split(" ");
            if (nameList.length == 3) {
              this.setState({
                firstName: nameList[0],
                middleName: nameList[1],
                lastName: nameList[2],
              });
            } else if (nameList.length == 2) {
              this.setState({
                firstName: nameList[0],
                lastName: nameList[1],
              });
            } else {
              this.setState({
                firstName: nameList[0],
              });
            }
            this.setState({
              ListOfExhibitorBadgeId: e.target.value,
              email: data.Email,
              mobile: data.MobileNo,
              isLoading: false,
            });
          }
        });
      } else {
        toastError("Exhibitor already selected");
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({
        ListOfExhibitorBadgeId: "",
        firstName: "",
        email: "",
        countryId: "",
        mobile: "",
        isLoading: false,
      });
    }
  }

  render() {
    const {
      isLoading,
      is_add,
      is_update,
      firstName,
      firstNameErr,
      middleName,
      lastName,
      lastNameErr,
      idTypeId,
      idTypeIdErr,
      passportFrontImage,
      passportFrontImageErr,
      countryId,
      countryIdErr,
      countryList,
      passportExpiryDate,
      passportExpiryDateErr,
      passportIssueDate,
      passportIssueDateErr,
      email,
      emailErr,
      passportNo,
      passportNoErr,
      mobile,
      mobileErr,
      visaApplicationList,
      idTypeList,
      passportImage,
      isDelOpen,
      isView,
      ListOfExhibitorBadgeList,
      ListOfExhibitorBadgeId,
      passportFilePath,
      url,
      isPassportView,
      ExhibitorName,
      ContactPerson,
      ContactNumber,
      HallNo,
      StallNo,
      StallArea, passportFrontImageList,
      fileIsFromBackend,
      RoleID,
      StatusID, isOpenConfirmationModal, isHideSection, Gender, DateofBirth, Nationality, EmbassyOrConsulateOfficeLocation, companyName, companyNameErr, companyList, IsMixExhibitor
    } = this.state;
    console.log("ptopppp", passportFrontImageList, this.props)
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />

        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
          JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
          JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
          <ExhibitorDrawer />
        ) : (
          <AdminDrawer />
        )}
        <div className={!isHideSection ? "with-dr-container" : ""} style={{ marginTop: RoleID == 1 ? "0px" : "" }}>
          <div className={`main-container ${RoleID == 2 || RoleID == 7 || RoleID == 17 || RoleID == 6 || RoleID == 9 || RoleID == 16 || RoleID == 25
            ? "tab-space"
            : RoleID == 1 || RoleID == 8
              ? "exb-top-space"
              : "admin-top-space-1"
            }`}>
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
            <div className="row mt-md-4 m-0">
              <div className="col-xl-12">
                <div className="card rounded-0 p-0 border">
                  <div className="card-header p-2">
                    <h3 className="card-title">
                      Invitation letter for visa Application
                    </h3>
                  </div>
                  <div className="card-body p-2 px-3 mt-1">
                    <div className="row">
                      <p className="text-danger">
                        (Please note that the visa invitation letter will be issued only after the registration is confirmed and 100% payment has been received.)
                      </p>
                    </div>
                    {/* {is_add && (
                      <div className="row mb-3">
                        <div className="col-xl-7">
                          <label>
                            List of Exhibitor{" "}
                            <span
                              className="text-red visa-note"
                              title={`You can request visa invitation letter only for exhibitor badges applied for ${sessionStorage.getItem(
                                "sessionExhibitionName"
                              )}`}
                            >
                              (
                              {`You can request visa invitation letter only for exhibitor badges applied for ${sessionStorage.getItem(
                                "sessionExhibitionName"
                              )}`}
                              )
                            </span>

                          </label>
                          <select
                            className="form-control"
                            value={ListOfExhibitorBadgeId}
                            disabled={isView || StatusID == 2}
                            onChange={(e) => this.onSelectListofExhibitor(e)}
                          >
                            <option value={""}>Select</option>
                            {ListOfExhibitorBadgeList.length > 0 &&
                              ListOfExhibitorBadgeList.map((data) => (
                                <option value={data.ExhBadgesFormID} key={data.ExhBadgesFormID}>
                                  {data.Name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    )} */}
                    <div className="mb-6">
                      {/* firstrow */}
                      <div className="row">
                        <div className="col-xl-4">
                          <label>Exhibitor Name</label>
                          <input
                            type="text"
                            className="form-control"
                            disabled
                            value={ExhibitorName}
                          />
                        </div>
                        <div className="col-xl-4">
                          <label>Contact Person</label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={ContactPerson}
                          />
                        </div>
                        <div className="col-xl-4">
                          <label>Contact Number</label>
                          <input
                            type="text"
                            disabled
                            className="form-control"
                            value={ContactNumber}
                          />
                        </div>
                      </div>

                      {/* secondrow */}
                      <div className="row mt-2">
                        <div className="col-xl-4">
                          <label>Hall No.</label>
                          <input type="text" disabled className="form-control" value={HallNo} />
                        </div>
                        <div className="col-xl-4">
                          <label>Stall No.</label>
                          <input type="text" disabled className="form-control" value={StallNo} />
                        </div>
                        <div className="col-xl-4">
                          <label>Area</label>
                          <input type="text" disabled className="form-control" value={StallArea} />
                        </div>
                      </div>
                    </div>
                    {/* <hr /> */}

                    {/* {(
                      is_add
                        ? ListOfExhibitorBadgeId != "" && ListOfExhibitorBadgeId != "Select"
                        : true
                    ) ? ( */}
                    <div className="mt-6">
                      {/* RM FIRST ROW */}
                      <div className="row">

                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Company Name <span className="text-red">*</span>
                          </label>
                          {IsMixExhibitor ?
                            <select
                              className="form-control"
                              value={companyName}
                              disabled={isView || StatusID == 2}
                              onChange={(e) => {
                                this.setState({
                                  companyName: e.target.value,
                                  companyNameErr: "",
                                });
                              }
                              }
                            >
                              <option value={''}>Select</option>
                              {companyList.length > 0 &&
                                companyList.map((data) => (
                                  <option key={data.CompanyName} value={data.CompanyName}>
                                    {data.CompanyName}
                                  </option>
                                ))}
                            </select> :
                            <input
                              type="text"
                              className="form-control"
                              id="validationCustom03"
                              disabled={true}
                              value={companyName}
                              onChange={(e) =>
                                this.setState({
                                  companyName: e.target.value,
                                  companyNameErr: "",
                                })
                              }
                            />
                          }
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {companyNameErr}
                            </span>
                          }
                        </div>

                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            First Name (As per Passport)<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            disabled={isView || StatusID == 2}
                            required=""
                            maxLength={"50"}
                            value={firstName}
                            onChange={(e) =>
                              this.setState({ firstName: e.target.value, firstNameErr: "" })
                            }
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {firstNameErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Middel Name (As per Passport)
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            maxLength={"50"}
                            value={middleName}
                            disabled={isView || StatusID == 2}
                            onChange={(e) => this.setState({ middleName: e.target.value })}
                          />
                        </div>
                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Last Name (As per Passport)<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            required=""
                            value={lastName}
                            maxLength={"50"}
                            disabled={isView || StatusID == 2}
                            onChange={(e) =>
                              this.setState({ lastName: e.target.value, lastNameErr: "" })
                            }
                          />

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {lastNameErr}
                            </span>
                          }
                        </div>

                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Email<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            required=""
                            maxLength={"50"}
                            value={email}
                            disabled={isView || StatusID == 2}
                            // onChange={(e) => this.setState({ email: e.target.value, emailErr: '' })}
                            onChange={(e) => this.emailValidation(e)}
                          />

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {emailErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Select Passport issue in Country
                            <span className="text-red">*</span>
                          </label>
                          <select
                            className="form-control"
                            value={countryId}
                            disabled={isView || StatusID == 2}
                            onChange={(e) =>
                              this.setState({
                                countryId: e.target.value != "" && e.target.value,
                                countryIdErr: "",
                              })
                            }
                          >
                            <option value={""}>Select</option>
                            {countryList.length > 0 &&
                              countryList.map((data) => (
                                <option value={data.Code} key={data.Code}>
                                  {data.Description}
                                </option>
                              ))}
                          </select>

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {countryIdErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Mobile<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            required=""
                            maxLength={"20"}
                            value={mobile}
                            disabled={isView || StatusID == 2}
                            // onChange={(e) => this.setState({ mobile: e.target.value, mobileErr: '' })}
                            onChange={(e) => this.mobileValidation(e)}
                          />

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {mobileErr}
                            </span>
                          }
                        </div>
                        {/* RM last Row */}
                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Passport No<span className="text-red">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            maxLength={"20"}
                            required=""
                            value={passportNo}
                            disabled={isView || StatusID == 2}
                            onChange={(e) =>
                              this.setState({ passportNo: e.target.value, passportNoErr: "" })
                            }
                          />

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {passportNoErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-4">
                          <label className="">
                            Passport issue Date
                            <span className="text-red">*</span>
                          </label>
                          <DatePicker
                            selected={passportIssueDate}
                            onChange={(date) =>
                              this.setState({
                                passportIssueDate: new Date(
                                  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
                                ),
                                passportIssueDateErr: "",
                              })
                            }
                            disabled={isView || StatusID == 2}
                            dateFormat={"dd/MM/yyyy"}
                            className="form-control"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            maxDate={passportExpiryDate}
                            dropdownMode="select"
                            placeholderText="Passport Issued Date"
                            dayClassName={() => "example-datepicker-day-class"}
                            popperClassName="example-datepicker-class"
                          />
                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {passportIssueDateErr}
                            </span>
                          }
                        </div>
                        <div className="col-xl-4">
                          <label>
                            Passport Expiry Date
                            <span className="text-red">*</span>
                          </label>
                          <DatePicker
                            selected={passportExpiryDate}
                            onChange={(date) =>
                              this.setState({
                                passportExpiryDate: new Date(
                                  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
                                ),
                                passportExpiryDateErr: "",
                              })
                            }
                            disabled={isView || StatusID == 2}
                            dateFormat={"dd/MM/yyyy"}
                            className="form-control"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            minDate={passportIssueDate}
                            dropdownMode="select"
                            placeholderText="Passport Expiry Date"
                            dayClassName={() => "example-datepicker-day-class"}
                            popperClassName="example-datepicker-class"
                          />

                          {
                            <span className="text-danger text-start text-left d-block mt-1">
                              {passportExpiryDateErr}
                            </span>
                          }
                        </div>

                        <div className="col-xl-4">
                          <label className="">
                            Gender
                          </label>

                          <select
                            className="form-control"
                            // style={{ textAlign: "left" }}
                            value={Gender}
                            disabled={isView || StatusID == 2}
                            onChange={(e) => this.setState({ Gender: e.target.value })}
                          >
                            <option value={''}>Select</option>
                            {this.state.genderList.length > 0 &&
                              this.state.genderList.map((data) => (
                                <option key={data.GenderID} value={data.GenderID}>
                                  {data.Name}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="col-xl-4">
                          <label className="">
                            Date of Birth
                          </label>
                          <DatePicker
                            selected={DateofBirth}
                            onChange={(date) =>
                              this.setState({
                                DateofBirth: new Date(
                                  Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
                                ),
                              })
                            }
                            disabled={isView || StatusID == 2}
                            dateFormat={"dd/MM/yyyy"}
                            className="form-control"
                            peekNextMonth
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            placeholderText="Passport Issued Date"
                            dayClassName={() => "example-datepicker-day-class"}
                            popperClassName="example-datepicker-class"
                          />
                        </div>

                        <div className="col-xl-4">
                          <label htmlFor="validationCustom03">
                            Nationality
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            maxLength={"20"}
                            required=""
                            value={Nationality}
                            disabled={isView || StatusID == 2}
                            onChange={(e) =>
                              this.setState({ Nationality: e.target.value })
                            }
                          />
                        </div>

                        <div className="col-xl-4 mt-2">
                          <label htmlFor="validationCustom03">
                            Embassy/Consulate General Location for Application
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="validationCustom03"
                            maxLength={"20"}
                            required=""
                            value={EmbassyOrConsulateOfficeLocation}
                            disabled={isView || StatusID == 2}
                            onChange={(e) =>
                              this.setState({ EmbassyOrConsulateOfficeLocation: e.target.value })
                            }
                          />
                        </div>

                      </div>

                      <div className="file-upload-container">
                        <div className="row mt-4 mb-0" style={{ pointerEvents: "none" }}>
                          <div className="col-md-3" style={{ pointerEvents: "auto" }}>
                            <strong>
                              <label>
                                Passport Document <span style={{ color: "red" }}>*</span>
                              </label>
                            </strong>

                            {/* FILE PREVIEW - ONLY WHEN FILE EXISTS */}
                            {/* FILE PREVIEW - BULLETPROOF VERSION */}
                            {(passportFrontImage || fileIsFromBackend) && (
                              <div
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  padding: "5px 16px",
                                  margin: "10px 0",
                                  borderRadius: "20px",
                                  backgroundColor: "#f0f0f0",
                                  gap: "12px",
                                  position: "relative",
                                }}
                              >
                                <span
                                  style={{
                                    color: "#0066ffff",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                    fontSize: "14px",
                                    pointerEvents: "auto",
                                  }}
                                >
                                  {this.state.fileIsFromBackend &&
                                    this.state.passportFilePath ? (
                                    <a
                                      target="_blank"
                                      href={`${BASE_URL.split("/api")[0] + this.state.passportFilePath
                                        }`}
                                    >
                                      <span className="file-name-ellipsis">
                                        {passportFrontImage}
                                      </span>
                                    </a>
                                  ) : (
                                    <a
                                      onClick={(e) => {
                                        this.openPassportFile(
                                          this.state.passportFrontImageBase64,
                                          passportFrontImage
                                        );
                                      }}
                                    >
                                      <span className="file-name-ellipsis">
                                        {passportFrontImage}
                                      </span>
                                    </a>
                                  )}
                                </span>

                                {!isView && (
                                  <span
                                    role="button"
                                    aria-label="Remove file"
                                    style={{
                                      color: "#d32f2f",
                                      fontSize: "24px",
                                      fontWeight: "bold",
                                      cursor: "pointer",
                                      userSelect: "none",
                                      width: "30px",
                                      height: "30px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      borderRadius: "50%",
                                    }}
                                    onClick={(e) => {
                                      if (fileIsFromBackend) {
                                        this.removeBackendFile();
                                      } else {
                                        this.onCrossClick();
                                      }
                                    }}
                                  >
                                    ×
                                  </span>
                                )}
                              </div>
                            )}
                            {/* UPLOAD BUTTON - ONLY WHEN NO FILE */}
                            {!passportFrontImage && !fileIsFromBackend && (!isView || is_add || is_update) && (
                              <>
                                <input
                                  type="file"
                                  ref={(ref) => (this.fileInputRef = ref)}
                                  style={{ display: "none" }}
                                  accept=".jpg,.jpeg,.png,.pdf"
                                  onChange={(e) => {
                                    this.onFilePick(e, e.target.files);
                                    this.setState({ passportFrontImageErr: "" });
                                  }}
                                />
                                <span
                                  className="text-danger"
                                  style={{
                                    fontSize: "12px",
                                    display: "block",
                                  }}
                                >
                                  Max 5MB | Pdf,Jpeg,Jpg,Png only
                                </span>
                                <button
                                  type="button"
                                  className="btn btn-aqua mt-2"
                                  onClick={() => this.fileInputRef && this.fileInputRef.click()}
                                  style={{ width: "80%" }}
                                >
                                  Upload File
                                </button>
                              </>
                            )}

                            {/* ERROR */}
                            {passportFrontImageErr && (
                              <div className="text-danger small mt-1">
                                <i className="fa fa-exclamation-circle"></i>{" "}
                                {passportFrontImageErr}
                              </div>
                            )}
                          </div>
                          <div className="col-md-9 d-flex align-items-end justify-content-end" style={{ pointerEvents: "auto" }}>
                            <div
                              className="save-can justify-content-end d-flex w-100"
                              role="group"
                              aria-label="Basic example"
                            >
                              {!isHideSection &&
                                <button
                                  type="button"
                                  className="btn btn-gray"
                                  onClick={() => this.OnCancel()}
                                >
                                  Back
                                </button>
                              }
                              {is_add && (
                                <button
                                  type="button"
                                  className="btn btn-aqua mx-2"
                                  onClick={() => this.handleAddMore()}
                                >
                                  Add More
                                </button>
                              )}
                              {is_add && (
                                <button
                                  type="button"
                                  className="btn btn-aqua"
                                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Submit?`, buttonName: "Submit", action: 0 }, popArg: [] })}
                                >
                                  Submit
                                </button>
                              )}
                              {is_update && (
                                <button
                                  type="button"
                                  className="btn btn-aqua mx-2"
                                  onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: `Do you want to Update?`, buttonName: "Update", action: 1 }, popArg: [] })}
                                >
                                  Update
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ) : (
                      <></>
                    )} */}
                    {/* Add More button moved to the bottom row */}

                    {/* <hr /> */}
                    {
                      // isView && sessionStorage.getItem &&
                      //     JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 2 &&
                      isView && passportFilePath && (
                        <div>
                          <iframe
                            title="Passport Front and Back Page"
                            src={url + passportFilePath}
                            // src='https://ems_uat.india-itme.com/document/VisaApplication/GTTES25_50037/GTTES25_50037_visaApplication_30.pdf'
                            style={{ width: "800px", height: "1000px" }}
                          />
                        </div>
                      )
                    }

                    {this.renderVisaApplicationList()}

                    {/* Buttons moved up to the upload file row */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div >
        <Modal isOpen={isDelOpen} onRequestClose={() => this.setState({ isDelOpen: false })}>
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title">Confirm Delete</h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isDelOpen: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <p class="pop_label">Do you really want to delete this Document?</p>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-del-pop"
                    onClick={(e) => this.handleDelete(e)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isDelOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={isPassportView}
          onRequestClose={() => this.setState({ isPassportView: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title modal_title_text">Passport Example</h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isPassportView: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <img src="images/passport-eg.jpg"></img>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    addVisaApplication_action,
    getVisaApplicationDetails_action,
    updateVisaApplication_action,
    deleteVisaApplicationDoc_action,
    fill_action,
  })(InvitationVisaApplicationAU)
);
